module.exports = __webpack_public_path__ + "img/IMG_0328_L_Foamcore_MockedUp.84d1cc26.jpg";